import { Component, Input } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '@core/services/api/auth.service';

@Component({
    selector: 'shared-lock-alert',
    imports: [NgIcon, NgbAlert, TranslatePipe],
    template: `
        @if (authService.isLockByOther(lockedBy)) {
            <ngb-alert type="danger" [dismissible]="false" class="d-flex align-items-center gap-1">
                <ng-icon name="tablerAlertTriangle"/>
                <div>
                    <span class="fw-bold">{{ 'words.warning' | translate }} : </span> {{ 'others.page_currently_locked_by' | translate: { full_name: getFullName() } }}
                </div>
            </ngb-alert>
        }
    `
})
export class LockAlert {
    @Input() lockedBy: any | null = null;

    constructor(
        public authService: AuthService
    ) {
    }

    getFullName() {
        return this.lockedBy?.first_name + ' ' + this.lockedBy?.last_name;
    }
}
